import React from 'react'
import { string } from 'prop-types'

require('./BouncingBallLoader.scss')

const BouncingBallLoader = ({ headerText, subheaderText }) => {
    const hasText = headerText || subheaderText
    return (
        <div className="BouncingBallLoader" data-testid="ball-loader">
            {hasText && (
                <div className="text">
                    {headerText && <div className="headerText">{headerText}</div>}
                    {subheaderText && <div className="subheaderText">{subheaderText}</div>}
                </div>
            )}

            <div className="ball" />
        </div>
    )
}

BouncingBallLoader.defaultProps = {
    headerText: '',
    subheaderText: '',
}

BouncingBallLoader.propTypes = {
    headerText: string,
    subheaderText: string,
}
export default BouncingBallLoader
